import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Import from "@/pages/Import";
import ShoppingListPage from "@/pages/ShoppingList";
import SharedList from "@/pages/SharedList";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/import" element={<Import />} />
          <Route path="/list" element={<ShoppingListPage />} />
          <Route path="/shared/:shareId" element={<SharedList />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
